import { SupportedTokenName } from "@mezo/sdk"

const validateTokenAmount = (
  amount: string | undefined,
  balance: string,
  token: SupportedTokenName,
) => {
  if (amount === undefined || amount === "") return "Please enter an amount"

  const value = Number(amount)
  const maxValue = Number(balance)

  // TODO: The message should be updated
  if (value === 0) return "Please enter an amount"

  const isMaximumValueExceeded = value > maxValue

  if (isMaximumValueExceeded) return `Not enough ${token}`

  return undefined
}

export default {
  validateTokenAmount,
}
